export default __webpack_public_path__ + "static/media/team17.e4a2fa7d.JPG";